<template>
  <AccountModal
    v-if="showAccountModal"
    @closeModal="showAccountModal = !showAccountModal"
  />
  <ClientModal
    v-if="showClientModal"
    @closeModal="showClientModal = !showClientModal"
  />
  <PlanModal
    v-if="showPlanModal"
    @closeModal="showPlanModal = !showPlanModal"
  />
  <div
    class="navbar navbar-dark navbar-expand-lg navbar-static border-bottom border-bottom-white border-opacity-10"
  >
    <div class="container-fluid ps-1">
      <div
        v-if="currentRouteName === 'ProgressCourse'"
        class="d-flex d-lg-none me-2"
      >
        <button
          type="button"
          class="navbar-toggler sidebar-mobile-main-toggle rounded"
          title="Expandir/Recolher"
        >
          <i class="ph-list" />
        </button>
      </div>
      <div class="navbar-brand">
        <router-link
          to="/home"
          class="d-inline-flex align-items-center"
          title="Home"
        >
          <img src="@/assets/img/logo_mini.png" class="h-40px" alt="Logo" />
        </router-link>
      </div>
      <div class="d-xl-none">
        <button
          type="button"
          class="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#navbar-navigation"
          aria-expanded="true"
          title="Expandir/Recolher"
        >
          <i class="ph-list" />
        </button>
      </div>
      <div class="navbar-collapse collapse" id="navbar-navigation">
        <ul class="navbar-nav ms-auto">
          <li v-if="showLink" class="nav-item ms-lg-1">
            <router-link
              to="/users"
              class="navbar-nav-link rounded"
              :class="{
                active:
                  currentRouteName === 'Users' ||
                  currentRouteName === 'DetailsUser',
              }"
              title="Usuários"
            >
              <i class="ph-users-three me-2" />Usuários
            </router-link>
          </li>
          <li v-if="showLink" class="nav-item ms-lg-1">
            <router-link
              to="/roles"
              class="navbar-nav-link rounded"
              :class="{
                active:
                  currentRouteName === 'Roles' ||
                  currentRouteName === 'DetailsRole',
              }"
              title="Cargos"
            >
              <i class="ph-identification-card me-2" />Cargos
            </router-link>
          </li>
          <li v-if="showLink" class="nav-item ms-lg-1">
            <router-link
              to="/courses"
              class="navbar-nav-link rounded"
              :class="{
                active:
                  currentRouteName === 'Courses' ||
                  currentRouteName === 'DetailsCourse',
              }"
              title="Cursos"
            >
              <i class="ph-graduation-cap me-2" />Cursos
            </router-link>
          </li>
          <li v-if="showLink" class="nav-item dropdown ms-lg-1">
            <a
              href="#"
              class="navbar-nav-link rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="ph-chart-line-up me-2" />Relatórios
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <router-link
                to="/reports/users-progress"
                class="dropdown-item"
                title="Progresso dos Usuários"
              >
                <i class="ph-identification-badge me-2" />Progresso dos Usuários
              </router-link>
            </div>
          </li>
          <li class="nav-item dropdown ms-lg-1">
            <a
              href="#"
              class="navbar-nav-link rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="ph-user-circle me-2" />{{ user.name }}
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <button
                class="dropdown-item"
                @click="showAccountModal = true"
                title="Meu Perfil"
              >
                <i class="ph-user me-2" />Meu Perfil
              </button>
              <button
                v-if="user.isAdmin === 1"
                class="dropdown-item"
                @click="showClientModal = true"
                :title="`${
                  user.clientTypePerson === 1
                    ? 'Dados da Empresa'
                    : 'Meus Dados'
                }`"
              >
                <i class="ph-article me-2" /><span>
                  {{
                    user.clientTypePerson === 1
                      ? 'Dados da Empresa'
                      : 'Meus Dados'
                  }}
                </span>
              </button>
              <button
                v-if="user.isAdmin === 1"
                class="dropdown-item"
                @click="showPlanModal = true"
                title="Meus Planos"
              >
                <i class="ph-currency-circle-dollar me-2" />Meus Planos
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" @click="logout" title="Sair">
                <i class="ph-sign-out me-2" />Sair
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import AccountModal from '@/components/account/AccountModal.vue'
import ClientModal from '@/components/client/ClientModal.vue'
import PlanModal from '@/components/plan/PlanModal.vue'
import PATHS from '@/router/routesMap'

export default {
  name: 'Navbar',

  components: {
    AccountModal,
    ClientModal,
    PlanModal,
  },

  data() {
    return {
      showAccountModal: false,
      showClientModal: false,
      showPlanModal: false,
    }
  },

  computed: {
    user() {
      return this.$store.getters.user
    },

    currentRouteName() {
      return this.$route.name
    },

    showLink() {
      return this.user.isAdmin === 1 && this.user.clientTypePerson === 1
    },
  },

  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        localStorage.clear()
        this.$router.push(PATHS.BASE_URL)
      })
    },
  },
}
</script>

<style scoped>
.navbar {
  padding: 5px;
}
</style>
